import React from 'react';
import { Route, Redirect, Switch } from "react-router-dom";

import HistoryDetailPage from './HistoryDetailPage';
import StudyEvaluationListPage from './StudyEvaluationListPage';
import GeneratePage from './GeneratePage';
import GeneratedLogPage from './GeneratedLogPage';
import StudentAttendanceListPage from './Attendance/StudentAttendanceListPage';
import LecturerAttendanceListPage from './Attendance/LecturerAttendanceListPage';
import StudentAbsenceMaxListPage from './Attendance/StudentAbsenceMaxListPage';
// import ObePage from './Obe/ObePage';
// import ObeChartPage from './Obe/ObeChartPage';
import HistoryListPage from './HistoryListPage';
// import ObeClassListPage from './Obe/ObeClassListPage';
import NotEnrolledListPage from './Enrollment/NotEnrolledListPage';
import DocumentsPage from './Documents/DocumentsPage';
import DashboardPage from './DashboardPage';
import NotFound from '../utils/NotFound';

const Application = (prop:any) => {
    
    return (
        <Switch>
            <Route exact path="/">
                <DashboardPage data={prop} />
            </Route>
            <Route exact path="/generate" component={GeneratePage} />
            <Route exact path="/log" component={GeneratedLogPage} />
            <Route exact path="/process" component={StudyEvaluationListPage} />
            <Route exact path="/history" component={HistoryListPage} />
            <Route exact path="/detail" component={HistoryDetailPage} />
            <Route exact path="/student-absence" component={StudentAttendanceListPage} />
            <Route exact path="/lecturer-absence" component={LecturerAttendanceListPage} />
            {/* <Route exact path="/obe-class/" component={ObeClassListPage} /> */}
            <Route exact path="/student-absence-all" component={StudentAbsenceMaxListPage} />
            <Route exact path="/not-enrolled" component={NotEnrolledListPage} />
            {/* <Route exact path="/obe-input-grade/:strm/:class_nbr/:comp_seq_no" component={ObePage} />
            <Route exact path="/obe-outcome/:strm/:class_nbr" component={ObeChartPage} />
            <Route exact path="/obe-monitoring" component={ObeChartPage} /> */}
            <Route exact path="/documents" component={DocumentsPage} />
            <Route component={NotFound} />
        </Switch>
    )

}

export default Application;